<template>
  <v-row class="ofc-history">
    <v-col cols="12" class="fill-height">
      <v-card class="fill-height" style="overflow: auto;">
        <v-card-text>
          <v-list dense>
            <template v-if="loadedHH">
              <v-list-item>
                <v-list-item-content class="board">
                  <v-row>
                    <v-col cols="12">
                      <v-row dense>
                        <v-col cols="12">Hand #{{ loadedHH.hand_num }}</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="4" v-for="p in players(loadedHH)" :key="p.id">
                          <a color="blue" @click="openDNPDialog(p.code)" v-if="p.state.name !== activeChatAccountName">
                            <span>{{ p.state.name }}  {{ result(loadedHH, p.result) }}</span>
                          </a>
                          <span v-else>{{ p.state.name }}  {{ result(loadedHH, p.result) }}</span>
                          <br/>
                          <poker-card class="poker-card" v-for="c,idx in p.state.top" :key="c + idx" :card="getCard(c)"></poker-card> {{ rowResult(p.result, 'top') }}<br/>
                          <poker-card class="poker-card" v-for="c,idx in p.state.mid" :key="c + idx" :card="getCard(c)"></poker-card> {{ rowResult(p.result, 'mid') }}<br/>
                          <poker-card class="poker-card" v-for="c,idx in p.state.btm" :key="c + idx" :card="getCard(c)" ></poker-card> {{ rowResult(p.result, 'btm') }}<br/>
                          <poker-card class="poker-card discard" v-for="c in p.result.grave" :key="c" :card="getCard(c)"></poker-card><br/>

                          <p class="mb-0">Fantasy Games: {{ fantasy_games(p.state.id) }}</p>
                          <p class="mb-0">Fantasy Error: {{ fantasy_avg_err(p.state.id) }}</p>
                          <p class="mb-0">Fantasy Error x Us: {{ fantasy_avg_err_us(p.state.id) }}</p>
                          <p class="mb-0">Games: {{ games(p.state.id) }}</p>
                          <p class="mb-0">PPG: {{ formatNumber(ppg(p.state.id)) }}</p>
                          <p class="mb-0">Games x Us: {{ games_us(p.state.id) }}</p>
                          <p class="mb-0">PPG x Us: {{ formatNumber(ppg_us(p.state.id)) }}</p>
                          <p class="mt-3 mb-0"><strong>FL in a Row: <v-chip small style="font-size: 1.2em">{{ flInRowForId(p.state.id) }}</v-chip></strong></p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-btn color="secondary" :disabled="loadingHand" @click="loadHand(0, true)">First</v-btn>
                <v-btn color="primary"
                       @click="loadHand(loadedHH.prev_hand, true)" :disabled="!loadedHH || !loadedHH.prev_hand || loadingHand">
                  Hand #{{ loadedHH ? loadedHH.prev_hand || loadedHH.handNum - 1 : '?' }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary"
                       @click="loadHand(loadedHH.next_hand, true)" :disabled="!loadedHH || !loadedHH.next_hand || loadingHand">
                  Hand #{{ loadedHH ? loadedHH.next_hand || loadedHH.handNum + 1 : '?'  }}</v-btn>
                <v-btn color="secondary" @click="loadHand(-1, true)" :disabled="loadingHand">Last</v-btn>
                <v-progress-circular indeterminate v-if="loadingHand" color="primary"></v-progress-circular>
                <v-spacer></v-spacer>
                <v-checkbox v-model="followMostRecent" label="Follow Most Recent"></v-checkbox>
              </v-card-actions>
              <v-row dense>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-list-item class="d-flex justify-center">
                No hands available yet
              </v-list-item>
            </template>

          </v-list>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="askDNP" width="600">
      <v-card class="dialogCard">
        <v-card-title>Add DNP</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="dnpNote" outlined hide-details label="Note"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" text @click="dnpConfirm(true)" :disabled="dnpNote.length <= 2">DNP Global</v-btn>
          <v-btn color="orange" text @click="dnpConfirm(false)" :disabled="dnpNote.length <= 2">DNP {{ activeChatAccountName }}</v-btn>
          <v-btn color="red" text @click="dnpClear">Clear DNP</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="askDNP=false; dnpCode=null">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import PokerCard from '../PokerCard.vue';

export default {
  components: {
    'poker-card': PokerCard
  },
  data() {
    return {
      askDNP: false,
      dnpCode: null,
      dnpNote: "",
      timeout: null,
      opps: {},

      loadingHand: false,
      loadingHandTs: new Date().getTime(),
    };
  },
  computed: {
    loadedHH() {
      let hhInfo = this.pokerHandHistory(this.activeChatAccountName);
      if ((!hhInfo || !hhInfo.currently_viewing) && !this.loadingHand) {
        // no hand history -- trigger load the most recent one
        this.loadHand(-1);
        return null;
      }

      if (!hhInfo) return null;

      return hhInfo.currently_viewing;
    },
    followMostRecent: {
      get () {
        let hhInfo = this.pokerHandHistory(this.activeChatAccountName);
        if (!hhInfo) {
          // default follow most recent
          return true;
        }

        return hhInfo.follow_most_recent;
      },
      set (value) {
        this.$store.commit("setFollowMostRecent", {displayID: this.activeChatAccountName, followMostRecent: value});
      },
    },

    flInRow() {
      let as = this.automationStateFor(this.activeChatAccountName);
      if (!as) return {};
      if (!as.fantasy_land) return {};
      return as.fantasy_land.in_row;
    },

    ...mapGetters([
      'pokerHandHistory',
      'activeChatAccountName',
      'automationStateFor',
    ])
  },
  watch: {
    loadedHH() {
      // update displayed err rates whenever this changes
      this.updateErrorRate();
    }
  },

  mounted() {
    // update err rates as they change over time
    this.timeout = setInterval(() => {
      this.updateErrorRate(true);
    }, 60000);

    // and right away as well
    this.updateErrorRate(true);
  },
  unmounted() {
    clearInterval(this.timeout);
    this.timeout = null;
  },
  methods: {
    formatNumber(v, _d=2) {
      if (!v) return v;
      return (v).toFixed(_d).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    flInRowForId(playerId) {
      let fl = this.flInRow;
      if (!fl) return 0;
      if (!(playerId in fl)) return 0;
      return fl[playerId].length;
    },

    getCard(card) {
      let split = card.split("-");
      let newCard = split[split.length - 1];

      if (newCard === "Xb") {
        return "Yy";
      } else if (newCard === "Xr") {
        return "Zz";
      }

      return newCard;
    },
    loadHand(hand_num, overrideWait=false) {
      // called recently, wait
      if (!overrideWait && new Date().getTime() - this.loadingHandTs < 5000) return;

      // already loading
      if (this.loadingHand) return;

      this.loadingHand = true;
      this.loadingHandTs = new Date().getTime();

      // update tracking
      if (hand_num === -1) {
        // jumped to latest hand, follow most recent
        this.followMostRecent = true;
      } else {
        // we broke the cycle, don't follow last hand anymore
        this.followMostRecent = false;
      }

      let room_id = this.$store.state.states[this.activeChatAccountName].room_id;
      let gameType = this.$store.getters.gameType(this.activeChatAccountName);
      this.$store.dispatch("loadHand", {displayID: this.activeChatAccountName, roomId: room_id, gameType: gameType, handNum: hand_num}).then(() => {
        this.loadingHand = false;
      }).catch(() => {
        this.loadingHand = false;
      });
    },
    fantasy_games(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].fantasy_games;
    },
    fantasy_avg_err(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].fantasy_avg_err;
    },
    fantasy_avg_err_us(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].fantasy_avg_err_us;
    },
    ppg(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].ppg;
    },
    games(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].games;
    },
    games_us(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].games_us;
    },
    ppg_us(id) {
      if (!(id in this.opps)) return 0;
      return this.opps[id].ppg_us;
    },
    updateErrorRate(loadAll=false) {
      let listOfOpps = {};

      if (this.loadedHH) {
        for (let p of this.players(this.loadedHH)) {
          if (p.state.id in this.opps && !loadAll) continue;
          listOfOpps[p.state.id] = null;
        }
      }

      for (let pid in listOfOpps) {
        this.$axios.get("/api/fantasy_info/" + pid)
            .then((data) => {
                  let s = data.data.success;
                  // console.log(data.data);
                  if (!s) return;
                  let opp = data.data.opponent;

                  this.opps[pid] = {
                    "fantasy_avg_err": opp.error_fantasy_avg.toFixed(2),
                    "fantasy_games": opp.error_fantasy_games,
                    "fantasy_avg_err_us": opp.error_fantasy_avg_us.toFixed(2),
                    "games": opp.games,
                    "ppg": opp.games && opp.games > 0 ? opp.score / opp.games : 0,
                    "games_us": opp.games_us,
                    "ppg_us": opp.games_us && opp.games_us > 0 ? opp.score_us / opp.games_us : 0
                  }
            });
      }
    },

    players(st) {
      if (!st.raw_log) return [];
      if (!st.raw_log.handSummary) return [];

      if (!st.raw_log.handSummary.players) return [];

      let players = [...st.raw_log.handSummary.players];
      if (!players) return [];

      return players.sort((a, b) => {
        if (a.state.name === this.activeChatAccountName && b.state.name !== this.activeChatAccountName) {
          return -1;
        } else if (a.state.name !== this.activeChatAccountName && b.state.name === this.activeChatAccountName) {
          return 1;
        } else {
          return 0;
        }
      });

      // let players = [st.p1];
      // if (st.p2) {
      //   players.push(st.p2);
      // }
      // if (st.p3) {
      //   players.push(st.p3)
      // }
      // return players;
    },
    result(hh, playerResult) {
      if (!hh.raw_log || !hh.raw_log.settings) {
        return '';
      }
      let d = 1;
      if (hh.raw_log.settings.withDecimal) {
        d = 100;
      }
      try {
        let r = playerResult['stackChange'] / d;
        if (r > 0) {
          return '+' + (r.toFixed(2));
        }
        return r.toFixed(2);
      } catch (e) {
        console.log('error getting player result', e)
      }
      return '';
    },
    rowResult(result, row) {
      let r = 0;
      // console.log(row, 'result:', result, result[row])
      try {
        r = result[row]['score'];
        if (r > 0) {
          return '+' + r;
        }

      } catch {
        // pass?
      }
      return r;
    },

    openDNPDialog(code) {
      this.askDNP = true;
      this.dnpCode = code;
      this.dnpNote = "";
    },

    dnpConfirm(global=false) {
      this.$store.dispatch("addDNP", {
        type: global === true ? "global" : "account",
        note: this.dnpNote,
        code: this.dnpCode,
        account: this.activeChatAccountName
      })

      this.askDNP = false;
      this.dnpCode = null;
      this.dnpNote = "";
    },

    dnpClear() {
      this.$store.dispatch("clearDNP", {
        code: this.dnpCode,
        account: this.activeChatAccountName
      })

      this.askDNP = false;
      this.dnpCode = null;
      this.dnpNote = "";
    },
  }
}
</script>

<style scoped>
.v-card {
  /*height: 60vh !important;*/
  /*max-height: 60vh;*/
  /*height: 100% !important;*/
  /*min-height: 300px;*/
  /*overflow-y: auto;*/
}

.ofc-history {
  height: 100% !important;
  min-height: 300px;
  margin: 0;
}

.ofc-history > div {
  padding: 0;
}

.dialogCard {
  height: inherit !important;
}

.poker-card {
  display: inline-block;
  margin-left: 4px;
}
.discard {
  transform: scale(0.7);
}
.v-divider {
  background-color: lightgrey;
}
</style>
